// Copyright Epic Games, Inc. All Rights Reserved.
import { APP_BASE_PATH } from '@constants/app';

export const GATED_FLAGS = {
  MOBILE_EARLY_ADOPTER: 'mobile-early-adopter-program',
  KWS_UPFM_SELF_SERVE: 'kws-upfm-selfserve-docs',
} as const;

export type GatedFlag = (typeof GATED_FLAGS)[keyof typeof GATED_FLAGS];

export type FlagDenialMessage = {
  i18nKey: string;
  // Rendered into the message's <a> slot. Optional because a flag's own copy
  // may carry no link at all, not just the generic support-page one.
  buildCtaUrl?: (locale: string) => string;
};

export const DEFAULT_FLAG_DENIAL_MESSAGE: FlagDenialMessage = {
  i18nKey: 'AccessDeniedUnauthorized',
  // Relative to the app's own basePath, never the domain, so this keeps working
  // across ephemeral, GameDev and prod hosts.
  buildCtaUrl: () => `/${APP_BASE_PATH}/support`,
};

// Flags are declared free-form in content frontmatter and evaluated generically
// against LaunchDarkly, so this map is presentation only: a flag absent from it
// still gates correctly and falls back to the generic denial copy.
//
// Only register a flag here when its audience needs copy the generic message cannot
// give them — in practice, a self-serve intake route to link to. KWS is deliberately
// absent: its audience has no such route, so it takes the generic message via
// DEFAULT_FLAG_DENIAL_MESSAGE rather than a second key with identical text.
export const FLAG_DENIAL_MESSAGES: Record<string, FlagDenialMessage> = {
  [GATED_FLAGS.MOBILE_EARLY_ADOPTER]: {
    i18nKey: 'MobileEarlyAdopterUnauthorized',
    buildCtaUrl: (locale) => `https://forms.unrealengine.com/s/egs-lead-intake-form?language=${locale}`,
  },
};
